import { createSlice } from "@reduxjs/toolkit";
import { addOwnBook, getAllOwnBooks, deleteOwnBooks, fetchOwnBookById } from "../../../controller/addBook/premium/ownBooksController";
import errorHandler from "../../../utils/errorHandler";

const normalizeBooks = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.books)) return payload.books;
    if (Array.isArray(payload?.data?.books)) return payload.data.books;
    return [];
};

const initialState = {
    isLoading: false,
    isSuccess: false,
    ownBooks: [],
    selectedOwnBook: null,
    message: "",
    error: null
};

const ownBooksSlice = createSlice({
    name: 'ownBooks',
    initialState,
    extraReducers: {
        // Add Own Book
        [addOwnBook.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [addOwnBook.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.message = payload.data?.message || 'Book added successfully';
            state.error = null;
        },
        [addOwnBook.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.error = payload;
            errorHandler(payload);
        },

        // Get All Own Books
        [getAllOwnBooks.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [getAllOwnBooks.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.ownBooks = normalizeBooks(payload);
            state.error = null;
        },
        [getAllOwnBooks.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.error = payload;
            errorHandler(payload);
        },

        // Delete Own Books
        [deleteOwnBooks.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [deleteOwnBooks.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.ownBooks = normalizeBooks(payload);
            state.message = payload.message || 'Books deleted successfully';
            state.error = null;
        },
        [deleteOwnBooks.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.error = payload;
            errorHandler(payload);
        },

        // Fetch Own Book By Id
        [fetchOwnBookById.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [fetchOwnBookById.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.selectedOwnBook = payload;
            state.error = null;
        },
        [fetchOwnBookById.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.selectedOwnBook = null;
            state.error = payload || 'Failed to fetch book details';
        }
    }
});

export default ownBooksSlice.reducer;
